// Entry point to implement and test our tree-shaking abilities
import { CartesianChartModule } from './chart/cartesianChartModule';
import {
    FlowProportionChartModule,
    GaugeChartModule,
    HierarchyChartModule,
    StandaloneChartModule,
    TopologyChartModule,
} from './chart/enterpriseChartModules';
import { PolarChartModule } from './chart/polarChartModule';
import { NewAreaSeriesModule } from './chart/series/cartesian/areaSeriesModule';
import { NewBarSeriesModule } from './chart/series/cartesian/barSeriesModule';
import { NewBubbleSeriesModule } from './chart/series/cartesian/bubbleSeriesModule';
import { NewHistogramSeriesModule } from './chart/series/cartesian/histogramSeriesModule';
import { NewLineSeriesModule } from './chart/series/cartesian/lineSeriesModule';
import { NewScatterSeriesModule } from './chart/series/cartesian/scatterSeriesModule';
import { NewDonutSeriesModule } from './chart/series/polar/donutSeriesModule';
import { NewPieSeriesModule } from './chart/series/polar/pieSeriesModule';
import {
    CategoryAxisModule,
    GroupedCategoryAxisModule,
    LogAxisModule,
    NumberAxisModule,
    TimeAxisModule,
} from './module/axisModules';

export { ModuleRegistry } from 'ag-charts-core';

export {
    CartesianChartModule,
    NumberAxisModule,
    LogAxisModule,
    TimeAxisModule,
    CategoryAxisModule,
    GroupedCategoryAxisModule,
    NewAreaSeriesModule,
    NewBarSeriesModule,
    NewBubbleSeriesModule,
    NewHistogramSeriesModule,
    NewLineSeriesModule,
    NewScatterSeriesModule,
    PolarChartModule,
    NewDonutSeriesModule,
    NewPieSeriesModule,
};

export const AllCartesianCommunityModules = [
    CartesianChartModule,
    NumberAxisModule,
    LogAxisModule,
    TimeAxisModule,
    CategoryAxisModule,
    GroupedCategoryAxisModule,
    NewAreaSeriesModule,
    NewBarSeriesModule,
    NewBubbleSeriesModule,
    NewHistogramSeriesModule,
    NewLineSeriesModule,
    NewScatterSeriesModule,
];

export const AllPolarCommunityModules = [PolarChartModule, NewDonutSeriesModule, NewPieSeriesModule];

export const AllCommunityModules = [
    ...AllCartesianCommunityModules,
    ...AllPolarCommunityModules,

    // Enterprise placeholders
    FlowProportionChartModule,
    GaugeChartModule,
    HierarchyChartModule,
    StandaloneChartModule,
    TopologyChartModule,
];
